import { downloadFile } from '@mi-front/core';
import { apiClient } from '../../../api';

// This file previously contained Redux thunk actions that have been migrated to hooks.
// See: apps/app/src/modules/audit/hooks/useAuditPlayback.ts

export function auditDownloadAudio(p: { stationId: string; customId: string }) {
  downloadFile(
    apiClient.audit.getDownloadAudioUrl({
      ...p,
      download: true,
    }),
  );
}
